import { Link } from 'react-router';
import { EmptyState } from '../components/EmptyState.js';
import { Logo } from '../components/Logo.js';

export function NotFoundPage() {
  return (
    <main className="notfound">
      <div>
        <span className="brand" style={{ justifyContent: 'center', display: 'flex' }}>
          <Logo size={28} />
        </span>

        <EmptyState
          icon="slash"
          title="That page does not exist"
          description="The link may be out of date, or the conversation may have been removed."
          action={
            <Link to="/" className="btn btn--primary">
              Back to Orbit Sync
            </Link>
          }
        />
      </div>
    </main>
  );
}
